import React, { useEffect, useState } from 'react'
import { AlertType, KEY_CODE_ENTER, KEY_CODE_ESCAPE, classBorderLabelDark, classBt, classInput, classInputDark, classLabel, classLabelDark, classbtAzul, classbtColunasVermelho, classbtVermelho } from '../../Utils/Types'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { BiSolidDiscount } from 'react-icons/bi'
import { Funcoes } from '../../Utils/Funcoes'
import { MdOutlineAttachMoney } from 'react-icons/md'

type Props = {
    visible: boolean
    loading?: boolean
    lancarDescontoEvent: (dadosDesconto: string, filtro: string) => void
    closeModalEvent: () => void
}

export const ModalDesconto = React.memo(({ visible, loading, lancarDescontoEvent, closeModalEvent }: Props) => {

    const [desconto, setDesconto] = useState("0.00")

    const [visibleMsg, setVisibleMsg] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    const [field, setField] = useState('Porcentagem')

    useEffect(() => {

        if (visible) {

            let modal = document.getElementById('modal_venda_desconto')
            let modalContent = document.getElementById('modal_content_venda_desconto')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-500px]')
                    modalContent.classList.add('mt-24')
                }

                const aguarde = setTimeout(() => {
                    const inputDesconto = document.getElementById('inputDesconto')
                    if (inputDesconto) {
                        inputDesconto.focus()
                        clearTimeout(aguarde)
                    }
                }, 200)

            }

        } else {

            setDesconto("0.00")
            setField('Porcentagem')
            setVisibleMsg(false)

            let modal = document.getElementById('modal_venda_desconto')
            let modalContent = document.getElementById('modal_content_venda_desconto')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-500px]')
                    modalContent.classList.remove('mt-24')
                }
            }
        }
    }, [visible])

    useEffect(() => {
       
        const handleKeyPressEnter = (event: any) => {

            if ((event.code === KEY_CODE_ENTER || event.code === "NumpadEnter") && !loading) {

                if (visible) {
                    lancarDesconto()
                }
            }
        }

        const handleKeyPressESC = (event: any) => {

            if (event.code === KEY_CODE_ESCAPE) {

                if (visible) {

                    if (closeModalEvent) {
                        closeModalEvent()
                    }
                }
            }
        }

        document.addEventListener('keydown', handleKeyPressEnter)
        document.addEventListener('keydown', handleKeyPressESC)

        return () => {
            document.removeEventListener('keydown', handleKeyPressEnter)
            document.removeEventListener('keydown', handleKeyPressESC)
        }

    }, [desconto, visible, field, loading])

    const handleChangeField = (e: React.ChangeEvent<HTMLSelectElement>) => {

        const fieldMap: { [key: string]: string } = {
            'Porcentagem': 'Porcentagem',
            'Valor': 'Valor',
        }

        const selectedField = fieldMap[e.target.value]

        if (selectedField) {
            setField(selectedField)
            Inputfocus()
        }
    }

    const handleDesconto = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDesconto(Funcoes.MaskMoney(e.target.value))
    }

    const lancarDesconto = () => {

        if (visible) {

            setVisibleMsg(false)

            if (desconto != "") {

                lancarDescontoEvent(desconto, field)

            } else {

                const timer = setTimeout(() => {
                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("Digite um valor para o desconto")
                    clearTimeout(timer)
                }, 250)
            }

            Inputfocus()
        }

    }

    const Inputfocus = () => {
        const inputElement = document.getElementById("inputDesconto")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisibleMsg(false)
        Inputfocus()
    }

    return (

        <div id="modal_venda_desconto" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40`}>

            <div id="modal_content_venda_desconto" className={`relative flex flex-col w-[80%] sm:w-[50%] lg:w-[40%] xl:w-[30%] h-[220px] bg-white dark:bg-slate-600 rounded-lg mt-[-500px] transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                {/* Header */}
                <div className={`absolute top-0 flex w-full h-[70px] items-center pr-2 pt-2`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        {field === 'Valor' ? <MdOutlineAttachMoney size={20} className={`w-5 h-5 text-slate-700 dark:text-slate-100`} /> : <BiSolidDiscount size={20} className='w-5 h-5 text-slate-700 dark:text-slate-100' />}
                    </div>

                    <span className={`ml-4 text-lg text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>Lançar Desconto</span>

                </div>
                {/* Header */}

                {/* Body */}
                <div className={`absolute top-[70px] bottom-[60px] w-full grid grid-cols-12 items-center`}>

                    <div className={`relative col-span-6 mx-2`}>
                        <select id='filtroDesconto' className={`${classInput} ${classInputDark} h-[48px]`} disabled={loading} value={field} onChange={handleChangeField}>
                            <option value="Porcentagem">Porcentagem (%)</option>
                            <option value="Valor">Valor (R$)</option>
                        </select>
                        <label htmlFor="filtroDesconto" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Tipo de Desconto</label>
                    </div>

                    <div className={`relative col-span-6 mx-2`}>
                        <input id='inputDesconto' className={`${classInput} ${classInputDark} h-[48px] text-[18px]`} type='text' inputMode='numeric' placeholder='' autoComplete='off' disabled={loading}  value={desconto} onChange={handleDesconto} />
                        <label htmlFor="inputDesconto" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Desconto</label>
                    </div>

                </div>
                {/* Body */}

                {/* Footer */}
                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        onClick={closeModalEvent} disabled={loading}
                        className={`${classbtColunasVermelho} max-w-[150px]`}>
                        CANCELAR
                    </button>

                    <button
                        onClick={lancarDesconto} disabled={loading}
                        className={`${classbtAzul} ${classBt} max-w-[150px]`}>

                        {loading &&
                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                            </div>
                        }
                        {!loading ? `LANÇAR` : "AGUARDE"}

                    </button>

                </div>
                {/* Footer */}

            </div>

        </div>
    )
})